import { useContext } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../queryClient';
import { SessionContext } from 'auth/SessionProvider';
import { QueryServerKeys } from 'constants/QueryServerKeys';
import {
  getNotificationEvents,
  markNotificationEventsSeen,
} from 'services/notifications';

// Polls only while the tab is visible (react-query's default), so a portal left open in the background asks nothing.
export function useNotificationEvents() {
  const { user } = useContext(SessionContext);

  return useQuery({
    queryKey: [QueryServerKeys.NOTIFICATION.EVENTS, user?.uuid],
    queryFn: () => getNotificationEvents(),
    enabled: !!user?.uuid,
    refetchInterval: 60 * 1000,
  });
}

export function useMarkNotificationEventsSeen() {
  const { user } = useContext(SessionContext);

  return useMutation({
    mutationFn: (until: string) => markNotificationEventsSeen(until),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [QueryServerKeys.NOTIFICATION.EVENTS, user?.uuid],
      }),
  });
}
